import type { FC } from "react";
import React from "react";
import { KivraHeaderRouter } from "../header/KivraHeaderRouter";
import { ErrorMessage } from "../errors/ErrorMessage";

export const OldSignupNotification: FC = () => (
  <div style={{ minWidth: "250px" }}>
    <ErrorMessage />
    <KivraHeaderRouter />
  </div>
);
